import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// "오늘" 날짜(YYYY-MM-DD)를 로컬 타임존 기준으로 반환한다.
// `date.toISOString().split('T')[0]`는 UTC 기준으로 변환하므로, KST(UTC+9)에서
// 00:00~08:59 사이에는 하루 전 날짜가 나오는 버그가 있다 - 로컬 필드로 직접 조합한다.
export function toLocalDateString(date: Date): string {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, "0")
  const day = String(date.getDate()).padStart(2, "0")
  return `${year}-${month}-${day}`
}